import React, { useState, useEffect } from 'react'
import { useLocation } from "react-router-dom";
import { calculateAsExceptionDepreciation } from '../services/asset.service';
import * as CryptoJS from "crypto-js";
import ConfirmationModal from './ConfirmationModal';
import * as XLSX from 'xlsx';
function MultiListAsExceptionPopUp(props) {
    const [showConfirmation, setShowConfirmation] = useState(false);
    var block = props.showExAs ? "display-block" : "";
    const [validName, setValidName] = useState(true);
    const [errMsg, setErrMsg] = useState('');
    const [warning, setWarning] = useState('');
    const [success, setSuccess] = useState(false);
    const [popupLoading, setPopupLoading] = useState(false);
    //const [overwriteDepExAs, setoverwriteDepExAs] = useState('No');
    const [overwriteBtn, setOverwriteBtn] = useState(false);
    const [financeInfoExAs, setfinanceInfoExAs] = useState(false);
    const [listOptionsExAs, setListDataExAs] = useState([]);

    // Progress states - managed internally
    const [progress, setProgress] = useState(0);
    const [total, setTotal] = useState(0);
    const [isProcessing, setIsProcessing] = useState(false);

    var asset_data_as = [...props.dataExAs];
    const [foundAssetsExAs, setFoundAssetsExAs] = useState(asset_data_as);
    const [failedRecords, setFailedRecords] = useState([]);
    const [successRecords, setSuccessRecords] = useState([]);

    const filter_as = (e) => {
        const keyword = e.target.value;
        if (keyword !== '') {
            const results = asset_data_as.filter((asset) => {
                return asset.tag.startsWith(keyword);
            });
            setFoundAssetsExAs(results);
        } else {
            setFoundAssetsExAs(asset_data_as);
        }
        setName(keyword);
    };

    const [back_url, setBackUrl] = useState(false);
    const useQuery = () => new URLSearchParams(useLocation().search);
    const query = useQuery();
    const Finance = query.get('finance');

    useEffect(() => {

        if (Finance != '' && Finance != null) {
            const decryptedBytes = CryptoJS.AES.decrypt(Finance.replace(/ /g, '+'), process.env.REACT_APP_ENCRYPT_SECRET_KEY);
            const decrypt_data = JSON.parse(decryptedBytes.toString(CryptoJS.enc.Utf8));
            setBackUrl(decrypt_data?.back_url);
            setfinanceInfoExAs(decrypt_data);
        }
        setFoundAssetsExAs(asset_data_as);
        //setListDataExAs(listOptionsExAs);

    }, []);

    const [name, setName] = useState('');

    const handleSubmit = async (e) => {
        e.preventDefault();
        var valid_Name = true;

        if (financeInfoExAs.finance_year === '') {
            setValidName(false);
            alert("Financial year is missing");
            valid_Name = false;
        }
        if (financeInfoExAs.finance_month === '') {
            setValidName(false);
            alert('Month is missing');
            valid_Name = false;
        }
        if (listOptionsExAs.length === 0) {
            setValidName(false);
            alert('Please select atleast one Asset');
            valid_Name = false;
        }

        if (!valid_Name) {
            return false;
        } else {
            // Reset and start processing
            setProgress(0);
            setTotal(0);
            setIsProcessing(true);

            // Update parent loading state
            if (props.setLoadingAs) props.setLoadingAs(true);
            if (props.setProgress) props.setProgress(0);
            if (props.setTotal) props.setTotal(0);

            try {
                await saveData();
            } catch (err) {
                console.error("Error saving:", err);
            } finally {
                setIsProcessing(false);
                if (props.setLoadingAs) props.setLoadingAs(false);
            }
        }
    }
    function getMonthName(monthNumber) { //alert(monthNumber);
        const month = Number(monthNumber); // force number
        if (month < 1 || month > 12) return "Invalid month";
        let full_month = new Date(2000, month - 1, 1).toLocaleString('en-US', {
            month: 'long'
        });
        //alert(full_month);
        return full_month;
    }
    // Function to download records as Excel
    const downloadRecordsExAsExcel = (records, batchId, filename, status) => {
        if (!records || records.length === 0) {
            alert('No records to download');
            return;
        }
        const excelData = records.map((record, index) => ({
            'S.No': index + 1,
            'Asset Tag': record,
            'Status': status,
            'batch': batchId,
            'Date': new Date().toLocaleDateString(),
            //'Time': new Date().toLocaleTimeString()
        }));

        const worksheet = XLSX.utils.json_to_sheet(excelData);

        // Set column widths
        worksheet['!cols'] = [
            { wch: 8 },   // S.No
            { wch: 55 },  // Asset Tag
            { wch: 15 },  // Status
            { wch: 15 },  // batchid
            { wch: 15 },  // Date
            //{ wch: 15 }   // Time
        ];

        const workbook = XLSX.utils.book_new();
        const sheetName = (typeof status === 'string' && status.trim()) ? status.trim().slice(0, 31) : 'Records';
        XLSX.utils.book_append_sheet(workbook, worksheet, sheetName);

        const timestamp = new Date().toISOString().replace(/[:.]/g, '-').slice(0, -5);
        XLSX.writeFile(workbook, `Depr_Excep_Ind_AS_${filename}_${timestamp}.xlsx`);
    }
    const handleoverwriteDepExAs = async (e) => {
        e.preventDefault();
        setShowConfirmation(true);
    }
    const handleConfirmOverwrite = async () => {
        setShowConfirmation(false);

        // Reset and start processing
        setProgress(0);
        setTotal(0);
        setIsProcessing(true);

        // Update parent loading state
        if (props.setLoadingAs) props.setLoadingAs(true);
        if (props.setProgress) props.setProgress(0);
        if (props.setTotal) props.setTotal(0);

        try {
            await saveData('Yes');
        } catch (err) {
            console.error("Error saving:", err);
        } finally {
            setIsProcessing(false);
            if (props.setLoadingAs) props.setLoadingAs(false);
        }
    };

    const handleCancelOverwrite = () => {
        setShowConfirmation(false);
    };
    const saveData = async (overwrite = 'No') => {
        const obj = {
            'owerwrite_dep': overwrite,
            'session': financeInfoExAs.finance_year,
            'month': financeInfoExAs.finance_month,
            'assets': listOptionsExAs,
            'company_id': sessionStorage.getItem('LoggedInCompanyId'),
            'division_id': sessionStorage.getItem('LoggedInDivisionId'),
            'created_by': sessionStorage.getItem('LoggedInUserId'),
        };

        const EncryptData = CryptoJS.AES.encrypt(
            JSON.stringify({
                'param_data': obj,
                'authToken': sessionStorage.getItem('LoggedInToken'),
            }),
            process.env.REACT_APP_ENCRYPT_SECRET_KEY
        ).toString();

        let oData = { 'token': EncryptData }

        try {
            setErrMsg('');
            setSuccess('');
            // Call the service function
            const response = await calculateAsExceptionDepreciation(oData);

            if (!response.ok) {
                throw new Error(`HTTP error! status: ${response.status}`);
            }
            //const response = await calculateAsExceptionDepreciation(oData);

            const reader = response.body.getReader();
            const decoder = new TextDecoder();
            let buffer = '';
            let finalMessage = null;

            // Read the stream in real-time
            while (true) {
                const { done, value } = await reader.read();

                if (done) {
                    console.log('Stream complete');
                    break;
                }

                // Decode the chunk and add to buffer
                buffer += decoder.decode(value, { stream: true });

                // Process complete lines from buffer
                const lines = buffer.split('\n');
                buffer = lines.pop() || ''; // Keep incomplete line in buffer

                for (const line of lines) {
                    if (!line.trim().startsWith('data:')) continue;

                    try {
                        const jsonStr = line.substring(5).trim();
                        if (!jsonStr) continue;

                        const data = JSON.parse(jsonStr);
                        console.log('Parsed data:', data);

                        // Update progress IMMEDIATELY as data arrives
                        if (data.count !== undefined && data.total !== undefined) {
                            console.log(`✓ Progress update: ${data.count}/${data.total}`);

                            setProgress(data.count);
                            setTotal(data.total);

                            if (props.setProgress) props.setProgress(data.count);
                            if (props.setTotal) props.setTotal(data.total);
                        }

                        // Capture final message
                        if (data.message) {
                            console.log('✓ Message received:', data.message);
                            finalMessage = data.message;
                        }

                        // Handle immediate errors
                        if (data.error) {
                            console.error('✗ Error received:', data.error);
                            setErrMsg(data.error);
                            setSuccess('');
                            setIsProcessing(false);
                            if (props.setLoadingAs) props.setLoadingAs(false);
                            return;
                        }

                        // Process completion
                        if (data.done) {
                            console.log('✓ Done signal received');
                            if (finalMessage) {
                                handleMessage(finalMessage);
                            } else {
                                setSuccess('Depreciation calculation completed.');
                            }

                            setTimeout(() => {
                                setIsProcessing(false);
                                if (props.setLoadingAs) props.setLoadingAs(false);
                                setProgress(0);
                                setTotal(0);
                            }, 1500);
                            return;
                        }
                    } catch (parseError) {
                        console.error('Failed to parse line:', line, parseError);
                    }
                }
            }
            if (finalMessage) {
                handleMessage(finalMessage);
            } else {
                setSuccess('Process completed.');
            }

            // Hide progress bar after completion
            setTimeout(() => {
                setIsProcessing(false);
                if (props.setLoadingAs) props.setLoadingAs(false);
                setProgress(0);
                setTotal(0);
            }, 1500);

        } catch (err) {
            console.error('Save data error:', err);
            setSuccess('');
            setErrMsg(
                err?.response?.data?.message ||
                err?.message ||
                'Failed to calculate depreciation. Please try again.'
            );
            setIsProcessing(false);
        }
    }

    const handleMessage = (message) => {

        if (!message) {
            setSuccess('Operation completed');
            return;
        }

        // Handle warning messages (existing logic)
        setOverwriteBtn(false);

        if (message.warning) {
            const tags = Array.isArray(message.warningTags) ? message.warningTags : [];
            //const tagList = tags.length > 0 ? tags.join(', ') : '';

            let msgText = message.warning_msg || '';
            if (Array.isArray(message.warningTags) && message.warning_msg == 'Already Exist') {
                setOverwriteBtn(true);
            }
            setWarning(<div><strong>{msgText}</strong> {tags.length > 0 && tags.length <= 5
                ? ': ' + tags.join(', ')
                : tags.length > 5
                    ? ` (${tags.slice(0, 3).join(', ')} and ${tags.length - 3} more)`
                    : ''
            } {message.warning_msg === 'Already Exist' ? 'Do you want to overwrite the existing records?' : ''} {tags.length > 0 && (
                <div style={{ marginTop: '10px' }}>
                    <button
                        onClick={() => downloadRecordsExAsExcel(tags, message.batchId, 'Failed_Records', msgText)}
                        className="btn btn-sm btn-warning"
                        style={{
                            display: 'inline-flex',
                            alignItems: 'center',
                            gap: '5px',
                            padding: '5px 12px'
                        }}
                    >
                        <i className="bi bi-download"></i>
                        Download Records (Excel)
                    </button>
                </div>
            )}</div>);
            //setErrMsg(msg);
            setSuccess('');

            return;
        }

        // Handle summary message with counts
        if (message.successCount !== undefined || message.failureCount !== undefined) {
            const { successCount = 0, failureCount = 0, successTags = [], failedTags = [], batchId = 0, total = 0 } = message;
            // Store records for download
            setSuccessRecords(successTags);
            setFailedRecords(failedTags);
            if (failureCount === 0 && successCount > 0) {
                // All successful
                setSuccess(<div>Successfully generated depreciation for {successCount} asset {successCount > 1 ? 's' : ''}
                    {successTags.length > 0 && successTags.length <= 5
                        ? ': ' + successTags.join(', ')
                        : successTags.length > 5
                            ? ` (${successTags.slice(0, 3).join(', ')} and ${successTags.length - 3} more)`
                            : ''
                    }
                    {successTags.length > 0 && (
                        <div style={{ marginTop: '10px' }}>
                            <button
                                onClick={() => downloadRecordsExAsExcel(successTags, batchId, 'Success_Records', 'Success')}
                                className="btn btn-sm btn-success"
                                style={{
                                    display: 'inline-flex',
                                    alignItems: 'center',
                                    gap: '5px',
                                    padding: '5px 12px'
                                }}
                            >
                                <i className="bi bi-download"></i>
                                Download Success Records (Excel)
                            </button>
                        </div>
                    )}
                </div>
                );
                setErrMsg('');
            } else if (successCount === 0 && failureCount > 0) {
                // All failed
                setErrMsg(<div>
                    Failed to generate depreciation for {failureCount} asset {failureCount > 1 ? 's' : ''}  {
                        failedTags.length > 0 && failedTags.length <= 5
                            ? ': ' + failedTags.join(', ')
                            : failedTags.length > 5
                                ? ` (${failedTags.slice(0, 3).join(', ')} and ${failedTags.length - 3} more)`
                                : ''
                    }
                    {failedTags.length > 0 && (
                        <div style={{ marginTop: '10px' }}>
                            <button
                                onClick={() => downloadRecordsExAsExcel(failedTags, batchId, 'Failed_Records', 'Failed')}
                                className="btn btn-sm btn-danger"
                                style={{
                                    display: 'inline-flex',
                                    alignItems: 'center',
                                    gap: '5px',
                                    padding: '5px 12px'
                                }}
                            >
                                <i className="bi bi-download"></i>
                                Download Failed Records (Excel)
                            </button>
                        </div>
                    )}
                </div>
                );
                setSuccess('');

            } else if (successCount > 0 && failureCount > 0) {
                // Partial success
                setSuccess(
                    <div>
                        Generated depreciation for {successCount} of {total} assets. {failureCount} failed.
                        {successTags.length > 0 && (
                            <div style={{ marginTop: '10px' }}>
                                <button
                                    onClick={() => downloadRecordsExAsExcel(successTags, batchId, 'Success_Records', 'Success')}
                                    className="btn btn-sm btn-success me-2"
                                    style={{
                                        display: 'inline-flex',
                                        alignItems: 'center',
                                        gap: '5px',
                                        padding: '5px 12px'
                                    }}
                                >
                                    <i className="bi bi-download"></i>
                                    Download Success ({successTags.length})
                                </button>
                            </div>
                        )}
                    </div>
                );
                setErrMsg(
                    <div>Failed assets {
                        failedTags.length > 0 && failedTags.length <= 5
                            ? ': ' + failedTags.join(', ')
                            : failedTags.length > 5
                                ? `: ${failedTags.slice(0, 3).join(', ')} and ${failedTags.length - 3} more`
                                : ''
                    }
                        {failedTags.length > 0 && (
                            <div style={{ marginTop: '10px' }}>
                                <button
                                    onClick={() => downloadRecordsExAsExcel(failedTags, batchId, 'Failed_Records', 'Failed')}
                                    className="btn btn-sm btn-danger"
                                    style={{
                                        display: 'inline-flex',
                                        alignItems: 'center',
                                        gap: '5px',
                                        padding: '5px 12px'
                                    }}
                                >
                                    <i className="bi bi-download"></i>
                                    Download Failed ({failedTags.length})
                                </button>
                            </div>
                        )}
                    </div>
                );
            }
            return;
        }

        // Handle legacy single result format
        const tags = Array.isArray(message.tags) ? message.tags : [];
        const tagList = tags.length > 0 ? tags.join(', ') : '';

        if (message.success === true || message.success === 'Inserted') {
            setSuccess(
                <div>Successfully Generated Depreciation {tagList ? '. Assets: ' + tagList : ''}
                    {tags.length > 0 && (
                        <div style={{ marginTop: '10px' }}>
                            <button
                                onClick={() => downloadRecordsExAsExcel(tags, message.batchId, 'Success_Records', 'Success')}
                                className="btn btn-sm btn-success"
                                style={{
                                    display: 'inline-flex',
                                    alignItems: 'center',
                                    gap: '5px',
                                    padding: '5px 12px'
                                }}
                            >
                                <i className="bi bi-download"></i>
                                Download Success Records (Excel)
                            </button>
                        </div>
                    )}
                </div>
            );
            setErrMsg('');
            return;
        }

        if (message.success === false) {
            setErrMsg(
                <div> Depreciation calculation failed. {tagList ? ' Assets: ' + tagList : ''}
                    {tags.length > 0 && (
                        <div style={{ marginTop: '10px' }}>
                            <button
                                onClick={() => downloadRecordsExAsExcel(tags, message.batchId, 'Failed_Records', 'Failed')}
                                className="btn btn-sm btn-danger"
                                style={{
                                    display: 'inline-flex',
                                    alignItems: 'center',
                                    gap: '5px',
                                    padding: '5px 12px'
                                }}
                            >
                                <i className="bi bi-download"></i>
                                Download Failed Records (Excel)
                            </button>
                        </div>
                    )}
                </div>
            );
            setSuccess('');
            return;
        }
        setErrMsg('Process completed with unclear result.');
        setSuccess('');
    };

    const handleMoveList1 = (e) => {
        const options1 = document.getElementById('lstBoxExAs').options;
        const newSelections = [];

        for (let i = 0; i < options1.length; i++) {
            if (options1[i].selected) {
                const option1 = {
                    label: options1[i].label || options1[i].text,
                    value: options1[i].value,
                };

                const exists = listOptionsExAs.some(
                    (item) => item.value === option1.value
                );

                if (!exists) {
                    newSelections.push(option1);
                }
            }
        }

        if (newSelections.length > 0) {
            setListDataExAs((prev) => [...prev, ...newSelections]);
        }
    }

    const handleAllMoveList1 = (e) => {
        const options1 = document.getElementById('lstBoxExAs').options;
        const newSelections = [];

        for (let i = 0; i < options1.length; i++) {
            const option1 = {
                label: options1[i].label || options1[i].text,
                value: options1[i].value,
            };

            const exists = listOptionsExAs.some(
                (item) => item.value === option1.value && item.label === option1.label
            );

            if (!exists) {
                newSelections.push(option1);
            }
        }

        setListDataExAs((prev) => [...prev, ...newSelections]);
    }

    const handleAllRemove = (e) => {
        setListDataExAs([]);
    }

    // Calculate percentage
    const percentage = total > 0 ? Math.round((progress / total) * 100) : 0;

    return (
        <>
            {/* Modal Backdrop */}
            {props.showExAs && (
                <div
                    className="modal-backdrop-custom"
                    style={{
                        position: 'fixed',
                        top: 0,
                        left: 0,
                        width: '100vw',
                        height: '100vh',
                        backgroundColor: 'rgba(0, 0, 0, 0.6)',
                        zIndex: 1040,
                        backdropFilter: 'blur(2px)',
                    }}
                />
            )}

            {/* Main Modal */}
            {props.showExAs && (
                <div
                    className="custom-modal"
                    style={{
                        position: 'fixed',
                        top: '50%',
                        left: '50%',
                        transform: 'translate(-50%, -50%)',
                        zIndex: 1050,
                        width: '85%',
                        height: '80%',
                        maxWidth: '1200px',
                        maxHeight: '90vh',
                        backgroundColor: '#ffffff',
                        borderRadius: '12px',
                        boxShadow: '0 10px 40px rgba(0, 0, 0, 0.2)',
                        overflow: 'hidden',
                        display: 'flex',
                        flexDirection: 'column'
                    }}
                >
                    {/* Modal Header */}
                    <div style={{
                        padding: '10px 15px',
                        borderBottom: '2px solid #e9ecef',
                        backgroundColor: '#f8f9fa',
                        display: 'flex',
                        justifyContent: 'space-between',
                        alignItems: 'center'
                    }}>
                        <h5 style={{
                            margin: 0,
                            fontSize: '1.25rem',
                            fontWeight: '600',
                            color: '#2c3e50'
                        }}>
                            {props.titleExAs}
                        </h5>
                        <h5>{getMonthName(financeInfoExAs.finance_month)}-{financeInfoExAs.finance_year}</h5>
                        <button
                            onClick={() => props.showsetterExAs(false)}
                            style={{
                                background: 'none',
                                border: 'none',
                                fontSize: '1.5rem',
                                cursor: 'pointer',
                                color: '#6c757d',
                                transition: 'color 0.2s',
                                padding: '0',
                                lineHeight: '1'
                            }}
                            onMouseEnter={(e) => e.target.style.color = '#dc3545'}
                            onMouseLeave={(e) => e.target.style.color = '#6c757d'}
                        >
                            <i className="bi bi-x-circle-fill"></i>
                        </button>
                    </div>

                    {/* Modal Body */}
                    <div style={{
                        padding: '15px',
                        overflowY: 'auto',
                        flex: 1
                    }}>
                        {/* Alert Messages */}
                        {success && (
                            <div className="alert alert-success" role="alert" style={{
                                display: 'flex',
                                alignItems: 'center',
                                gap: '10px',
                                marginBottom: '20px',
                                borderRadius: '8px'
                            }}>
                                <i className="bi bi-check-circle-fill" style={{ fontSize: '1.25rem' }}></i>
                                <span>{success}</span>
                            </div>
                        )}
                        {warning && (
                            <div className="alert alert-warning" role="alert" style={{
                                display: 'flex',
                                alignItems: 'center',
                                gap: '10px',
                                marginBottom: '20px',
                                borderRadius: '8px'
                            }}>
                                <i className="bi bi-check-circle-fill" style={{ fontSize: '1.25rem' }}></i>
                                <span>{warning}</span>
                            </div>
                        )}
                        {errMsg && (
                            <div className="alert alert-danger" role="alert" style={{
                                display: 'flex',
                                alignItems: 'center',
                                gap: '10px',
                                marginBottom: '20px',
                                borderRadius: '8px'
                            }}>
                                <i className="bi bi-exclamation-triangle-fill" style={{ fontSize: '1.25rem' }}></i>
                                <span>{errMsg}</span>
                            </div>
                        )}

                        {/* Progress Bar Section */}
                        {isProcessing && total > 0 && (
                            <div style={{
                                margin: '0 0 25px 0',
                                padding: '20px',
                                backgroundColor: '#f8f9fa',
                                borderRadius: '10px',
                                border: '1px solid #dee2e6'
                            }}>
                                <div style={{
                                    marginBottom: '12px',
                                    fontWeight: '600',
                                    color: '#495057',
                                    fontSize: '15px'
                                }}>
                                    <i className="bi bi-gear-fill" style={{ marginRight: '8px' }}></i>
                                    Generating IND AS Depreciation for {financeInfoExAs.finance_month}-{financeInfoExAs.finance_year}: {progress} of {total} ({percentage}%)
                                </div>
                                <div style={{
                                    width: '100%',
                                    height: '35px',
                                    backgroundColor: '#e9ecef',
                                    borderRadius: '8px',
                                    overflow: 'hidden',
                                    position: 'relative',
                                    boxShadow: 'inset 0 1px 2px rgba(0,0,0,0.1)'
                                }}>
                                    <div style={{
                                        width: `${percentage}%`,
                                        height: '100%',
                                        background: 'linear-gradient(90deg, #28a745 0%, #20c997 100%)',
                                        transition: 'width 0.3s ease',
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                        color: 'white',
                                        fontWeight: 'bold',
                                        fontSize: '14px',
                                        boxShadow: '0 2px 4px rgba(40, 167, 69, 0.3)'
                                    }}>
                                        {percentage}%
                                    </div>
                                </div>
                                <div style={{
                                    marginTop: '12px',
                                    fontSize: '13px',
                                    color: '#6c757d',
                                    textAlign: 'center',
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    gap: '6px'
                                }}>
                                    <i className="bi bi-info-circle-fill"></i>
                                    <span>Please don't refresh the page until the process is completed</span>
                                </div>
                            </div>
                        )}

                        {/* Multi-Select Section */}
                        <div style={{
                            display: 'grid',
                            gridTemplateColumns: '1fr auto 1fr',
                            gap: '20px',
                            alignItems: 'start'
                        }}>
                            {/* Left Box - Available Assets */}
                            <div style={{
                                backgroundColor: '#f8f9fa',
                                padding: '15px',
                                borderRadius: '10px',
                                border: '1px solid #dee2e6'
                            }}>
                                <label style={{
                                    fontWeight: '600',
                                    marginBottom: '10px',
                                    display: 'block',
                                    color: '#495057'
                                }}>
                                    Available Assets
                                </label>
                                <input
                                    type="search"
                                    value={name}
                                    onChange={filter_as}
                                    className="form-control"
                                    placeholder="🔍 Search assets..."
                                    style={{
                                        marginBottom: '10px',
                                        borderRadius: '6px',
                                        border: '1px solid #ced4da'
                                    }}
                                />
                                <select
                                    multiple
                                    id='lstBoxExAs'
                                    className="form-select form-select-sm"
                                    style={{
                                        minHeight: '250px',
                                        borderRadius: '6px',
                                        border: '1px solid #ced4da'
                                    }}
                                >
                                    {foundAssetsExAs && foundAssetsExAs.length > 0 ? (
                                        foundAssetsExAs.map((option, index) => (
                                            <option key={index} value={option.tag}>
                                                {option.tag}
                                            </option>
                                        ))
                                    ) : (
                                        <option disabled>No results</option>
                                    )}
                                </select>
                                <p style={{
                                    marginTop: '10px',
                                    fontSize: '13px',
                                    color: '#6c757d',
                                    fontWeight: '500'
                                }}>
                                    Total: {foundAssetsExAs?.length || 0}
                                </p>
                            </div>

                            {/* Center - Control Buttons */}
                            <div style={{
                                display: 'flex',
                                flexDirection: 'column',
                                gap: '10px',
                                alignItems: 'center',
                                paddingTop: '80px'
                            }}>
                                {popupLoading ? (
                                    <div className="spinner-border text-primary" role="status">
                                        <span className="visually-hidden">{popupLoading}</span>
                                    </div>
                                ) : null}

                                <button
                                    onClick={filter_as}
                                    value=""
                                    className="btn btn-info btn-sm"
                                    style={{
                                        width: '100px',
                                        borderRadius: '6px',
                                        fontWeight: '500'
                                    }}
                                >
                                    <i className="bi bi-arrow-clockwise"></i> Refresh
                                </button>

                                <div style={{
                                    height: '1px',
                                    width: '80%',
                                    backgroundColor: '#dee2e6',
                                    margin: '5px 0'
                                }}></div>

                                <button
                                    id='btnAllRight'
                                    onClick={handleAllMoveList1}
                                    className="btn btn-primary btn-sm"
                                    disabled={isProcessing}
                                    style={{
                                        width: '100px',
                                        borderRadius: '6px',
                                        fontWeight: '500'
                                    }}
                                >
                                    <i className="bi bi-chevron-double-right"></i> Add All
                                </button>

                                <button
                                    id='btnRight'
                                    onClick={handleMoveList1}
                                    className="btn btn-outline-primary btn-sm"
                                    disabled={isProcessing}
                                    style={{
                                        width: '100px',
                                        borderRadius: '6px',
                                        fontWeight: '500'
                                    }}
                                >
                                    <i className="bi bi-chevron-right"></i> Add
                                </button>

                                <button
                                    id='btnAllLeft'
                                    onClick={handleAllRemove}
                                    className="btn btn-outline-danger btn-sm"
                                    disabled={isProcessing}
                                    style={{
                                        width: '100px',
                                        borderRadius: '6px',
                                        fontWeight: '500'
                                    }}
                                >
                                    <i className="bi bi-chevron-double-left"></i> Remove All
                                </button>
                            </div>

                            {/* Right Box - Selected Assets */}
                            <div style={{
                                backgroundColor: '#f8f9fa',
                                padding: '15px',
                                borderRadius: '10px',
                                border: '1px solid #dee2e6'
                            }}>
                                <label style={{
                                    fontWeight: '600',
                                    marginBottom: '10px',
                                    display: 'block',
                                    color: '#495057'
                                }}>
                                    Selected Assets
                                </label>
                                <div style={{ height: '15px', marginBottom: '5px' }}></div>
                                <select
                                    multiple
                                    id='lstBox2'
                                    className="form-select form-select-sm"
                                    style={{
                                        minHeight: '250px',
                                        borderRadius: '6px',
                                        border: '1px solid #ced4da'
                                    }}
                                >
                                    {listOptionsExAs.map((option, index) => (
                                        <option key={index} value={option.value}>
                                            {option.label}
                                        </option>
                                    ))}
                                </select>
                                <p style={{
                                    marginTop: '5px',
                                    fontSize: '13px',
                                    color: '#6c757d',
                                    fontWeight: '500'
                                }}>
                                    Total: {listOptionsExAs.length}
                                </p>
                            </div>
                        </div>
                    </div>

                    {/* Modal Footer */}
                    <div style={{
                        padding: '10px 15px',
                        borderTop: '2px solid #e9ecef',
                        backgroundColor: '#f8f9fa',
                        display: 'flex',
                        justifyContent: 'flex-end',
                        gap: '10px'
                    }}>
                        <button
                            onClick={() => props.showsetterExAs(false)}
                            className="btn btn-secondary"
                            disabled={isProcessing}
                            style={{
                                minWidth: '100px',
                                borderRadius: '6px',
                                fontWeight: '500'
                            }}
                        >
                            <i className="bi bi-x-circle"></i> Close
                        </button>

                        {overwriteBtn ? (
                            <button
                                onClick={(e) => {
                                    e.preventDefault();
                                    props.datasetterExAs(asset_data_as);
                                    handleoverwriteDepExAs(e);
                                }}
                                className="btn btn-warning"
                                disabled={isProcessing || listOptionsExAs.length === 0}
                                style={{
                                    minWidth: '120px',
                                    borderRadius: '6px',
                                    fontWeight: '500'
                                }}
                            >
                                <i className="bi bi-pencil-square"></i> Overwrite
                            </button>
                        ) : (
                            <button
                                onClick={(e) => {
                                    e.preventDefault();
                                    props.datasetterExAs(asset_data_as);
                                    handleSubmit(e);
                                }}
                                className="btn btn-primary"
                                disabled={isProcessing || listOptionsExAs.length === 0}
                                style={{
                                    minWidth: '120px',
                                    borderRadius: '6px',
                                    fontWeight: '500'
                                }}
                            >
                                <i className="bi bi-gear-fill"></i> Generate
                            </button>
                        )}
                    </div>
                </div>
            )}

            {/* Confirmation Modal */}
            <ConfirmationModal
                show={showConfirmation}
                onConfirm={handleConfirmOverwrite}
                onCancel={handleCancelOverwrite}
                message="Are you sure you want to Overwrite? This action will replace existing data."
                title="Confirm Overwrite"
            />
        </>
    )
}

export default MultiListAsExceptionPopUp